import React from 'react';
import { Popover, Box } from '@mui/material';
import { AppointmentTypeChanges } from '../../types/appointmentChanges';
import { ExpandableFieldItem } from '@features/appointment-types';
import { UserTemplateItem } from '../../../../types/types';
import { CreateNewPreviewContent } from './CreateNewPreviewContent';

interface CreateNewPreviewPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  appointmentTypeName: string;
  changes?: AppointmentTypeChanges;
  currentDuration?: number;
  currentTelehealth?: boolean;
  currentForms?: ExpandableFieldItem[];
  currentReminders?: ExpandableFieldItem[];
  currentTemplate?: UserTemplateItem | null;
  onClose: () => void;
}

export const CreateNewPreviewPopover: React.FC<CreateNewPreviewPopoverProps> = ({
  open,
  anchorEl,
  appointmentTypeName,
  changes,
  currentDuration,
  currentTelehealth,
  currentForms = [],
  currentReminders = [],
  currentTemplate,
  onClose,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      sx={{
        pointerEvents: 'none',
        '& .MuiPopover-paper': {
          maxWidth: '80vw',
          minWidth: 300,
          width: 'fit-content', // Adjust width to content
        },
      }}
      marginThreshold={16} // Minimum distance from viewport edge
      disableRestoreFocus // Prevent focus issues
    >
      <Box sx={{ p: 2 }}>
        <CreateNewPreviewContent
          appointmentTypeName={appointmentTypeName}
          changes={changes}
          currentDuration={currentDuration}
          currentTelehealth={currentTelehealth}
          currentForms={currentForms}
          currentReminders={currentReminders}
          currentTemplate={currentTemplate}
        />
      </Box>
    </Popover>
  );
};

export default CreateNewPreviewPopover;
